import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import colors from "../../../../../colors";
import { ReactComponent as NoContractIcon } from "../../../../../../icons/noContracts.svg";
import { setIsUpgrading } from "../../../../../../features/registration/registrationSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { texts } from "../../../../../general/texts";

const MyContractsBasicAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    dispatch(setIsUpgrading(true));
    navigate("/register");
  };
  return (
    <Grid container item justifyContent={"center"} mt={5}>
      <Grid item md={12} xs={8}>
        <NoContractIcon />
      </Grid>
      <Grid item md={11} xs={11} mt={3}>
        <Typography
          sx={{
            color: colors.darkBlue,
            fontFamily: "GerberaLight",
            fontSize: "1.1rem",
          }}
        >
          {texts["message-complete-registration"]}
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Button
          onClick={handleButtonClick}
          sx={{
            background: colors.gradientOrange,
            color: colors.white,
            borderRadius: " 5px",
            fontSize: "0.9rem",
            fontFamily: "GerberaBold",
            textTransform: "none",
            mt: 10,
            width: "200px",
          }}
        >
          {texts["button-finish-registration"]}
        </Button>
      </Grid>
    </Grid>
  );
};
export default MyContractsBasicAccount;
